export const facilityProductKeys = {
    all: ['facilityProduct'] as const,
    list: (centerId: string) => [...facilityProductKeys.all, 'list', centerId] as const,
};
